module.exports = __webpack_public_path__ + "img/71244a2140262fa10f989b24ed9d51b0.png";